import {css} from '@emotion/core'
import styled from '@emotion/styled'
import {FontNormal} from "@css/fonts";
import {fontSize} from "@css/styles";
import {marketingMobileCuttoff} from "@css/constants";

export const CareersDescriptionContainer = styled('div')(css`
  border-bottom: 1px solid #e8e8e8;
  max-width: 1070px;
  margin: 0 auto;
  padding-top: 50px;
  padding-bottom: 30px;
  padding-left: 15px;
  padding-right: 15px;
`)

export const CareersDescriptionWrapper = styled('div')(css`
  display: flex;
  flex-direction: column;
  
  @media(min-width: ${marketingMobileCuttoff}) {
    flex-direction: row;
  }
`)

export const CareersDescriptionTitle = styled('div')(css`
  padding: 0 15px;
  display: flex;
  min-width: 182px;
`)

export const CareersDescriptionTitleText = styled('h2')(css`
  text-transform: uppercase;
  color: #333333;
  ${FontNormal(700)};
  margin-top: 30px;
  letter-spacing: 1px;
`)

export const CareersDescriptionContent = styled('div')(css`
  padding: 0 15px;
`)

export const CareersDescriptionContentItem = styled('div')(css`
  border-bottom: 1px solid #e8e8e8;
  padding-bottom: 12px;
  
  &:last-of-type {
    border-bottom: none;
  }
`)

export const ItemTitle = styled('h4')(css`
  ${FontNormal(600)};
  margin: 30px 0 20px;
  text-transform: uppercase;
  letter-spacing: 1px;
  color: #1a1c1f;
`)

export const ItemText = styled('div')(css`
  padding: 0;
  margin: 0;
`)

export const ItemParagraph = styled('p')(css`
  ${FontNormal(300)};
  ${fontSize(18)};
  padding: 0px;
  margin: 0px;
  color: #1a1c1f;
`)

export const IFrameContainer = styled('div')(css`
  margin-top: 45px;
`)
